import service from "../api/services/messageService";

export default {
  namespaced: true,
  state: {},

  mutations: {},
  actions: {
    getMessages(context, reqData) {
      return service
        .getMessages(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    sendMessage(context, reqData) {
      return service
        .sendMessage(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    broadcastMessage(context, reqData) {
      return service
        .broadcastMessage(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    getUserIdList(context, reqData) {
      return service
        .getUserIdList(reqData)
        .then((response = {}) => {
          return response.data.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    deleteMessage(context, reqData) {
      return service
        .deleteMessage(reqData)
        .then((response = {}) => {
          return response.data.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    updateNotificationReadStatus(context, reqData) {
      return service
        .updateNotificationReadStatus(reqData)
        .then((response = {}) => {
          return response.responseData;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
};
